import axios from '@/lib/AxApi';

export default
{
    selectRow(params, cb)
    {
        axios.get('/Modules/selectRow',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    getPossibleIcons(params, cb)
    {
        axios.get('/Modules/getPossibleIcons',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    save(params, cb)
    {
        axios.post('/Modules/updateRow', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    saveModuleUsers(params, cb)
    {
        axios.post('/Modules/updateUsers', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    activateModule(params, cb)
    {
        axios.post('/Modules/activateDevice', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    async setThermostat(params)
    {
        try
        {
            const response = await axios.post('/Modules/setThermostat', params);
            return response.data;
        }
        catch (error)
        {
            // TODO
        }
    },
    async setDimmer(params)
    {
        try
        {
            const response = await axios.post('/Modules/setDimmer', params);
            return response.data;
        }
        catch (error)
        {
            // TODO
        }
    },
    activateSecModule(params, cb)
    {
        axios.post('/Modules/activateSecDevice', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    getTemp(params, cb)
    {
        axios.post('/Modules/getTemp', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    reset(params, cb)
    {
        axios.post('/Modules/reset', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    deleteRow(params, cb)
    {
        axios.post('/Modules/deleteRow', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    }
}